import { Node } from '@tiptap/core';
import { File } from 'lucide-react';

export const S3File = Node.create({
    name: 's3File',
    group: 'block',
    draggable: true,
    selectable: true,
    atom: true,
    inline: false,
    allowGapCursor: true,

    addAttributes() {
        return {
            src: { default: null },
            key: { default: null },
            filename: { default: null },
            contentType: { default: null },
            fileSize: { default: null },
            uploadId: { default: null },
            textAlign: {
                default: 'left',
                parseHTML: element => element.getAttribute('data-text-align'),
            }
        };
    },

    parseHTML() {
        return [{
            tag: 'div[data-s3-file-key]',
            getAttrs: dom => ({
                src: dom.getAttribute('data-src'),
                key: dom.getAttribute('data-s3-file-key'),
                filename: dom.getAttribute('data-filename'),
                contentType: dom.getAttribute('data-content-type'),
                fileSize: dom.getAttribute('data-file-size'),
                uploadId: dom.getAttribute('data-upload-id'),
                textAlign: dom.getAttribute('data-text-align') || 'left',
            }),
        }];
    },

    renderHTML({ HTMLAttributes }) {
        const containerClasses = [
            's3-file-container',
            'node-s3File',
            'p-4',
            'rounded-lg',
            'border',
            'bg-muted/40',
            'hover:bg-muted/60',
            'transition-colors',
            'w-fit',
            'max-w-full',
            HTMLAttributes.uploadId ? 'animate-pulse' : '',
        ].filter(Boolean).join(' ');

        const fileSize = formatFileSize(HTMLAttributes.fileSize);

        return [
            'div',
            {
                class: containerClasses,
                'data-type': 's3-file',
                'data-s3-file-key': HTMLAttributes.key,
                'data-src': HTMLAttributes.src,
                'data-filename': HTMLAttributes.filename,
                'data-content-type': HTMLAttributes.contentType,
                'data-file-size': HTMLAttributes.fileSize,
                'data-upload-id': HTMLAttributes.uploadId,
                draggable: 'true'
            },
            [
                'div',
                { class: 'flex items-center justify-between gap-4' },
                [
                    'span',
                    { class: 'flex-1 truncate' },
                    `${HTMLAttributes.filename || 'File'} (${fileSize})`
                ],
                [
                    'a',
                    {
                        href: HTMLAttributes.src,
                        target: '_blank',
                        class: 'inline-flex items-center justify-center whitespace-nowrap rounded-md text-xs font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-6 px-2'
                    },
                    'Download'
                ]
            ]
        ];
    },

    addCommands() {
        return {
            setS3File: attributes => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: attributes
                });
            },
            updateS3File: attributes => ({ commands }) => {
                return commands.updateAttributes(this.name, attributes);
            }
        };
    },
});

function formatFileSize(bytes) {
    if (!bytes) return '';
    bytes = parseInt(bytes);
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}